/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SettlementDto } from '../../models/settlement-dto';
import { SettlementUpdateDto } from '../../models/settlement-update-dto';

export interface SettlementControllerUpdate$Params {

/**
 * 정산 ID
 */
  id: string;
      body: SettlementUpdateDto
}

export function settlementControllerUpdate(http: HttpClient, rootUrl: string, params: SettlementControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<SettlementDto>> {
  const rb = new RequestBuilder(rootUrl, settlementControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SettlementDto>;
    })
  );
}

settlementControllerUpdate.PATH = '/api/settlement/{id}';
